module.exports = __webpack_public_path__ + "static/media/31441374_1856610204358217_937884973271089152_n.8943a5b8.jpg";